import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import "../../styles/customers/createCustomer.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";

import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
class UploadCsv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerError: false,
      successMsg: false,
    };
  }
  async componentDidMount() {
    if (localStorage.getItem('role') === "SystemAdmin") {
      this.getCustomers();
    }
  }

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({
          customers: response.data,
          customerId: response.data[0].id,
        });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleCustomer = (evt) => {
    if (evt.target.value == "") {
      this.setState({ customerError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.state.customers.forEach((customer) => {
      if (customer.name == evt.target.value) {
        this.setState({ customerId: customer.id });
        //   this.getDepotList(customer.id);
      }
    });
  };

  validationCheck = (obj) => {
    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }
  };

  handleBack = () => {
    // this.props.history.push("/zones");
    this.props.history.goBack();
  };

  setFile = (e) => {
    if (
      e.target.files[0].name
        .substr(e.target.files[0].name.lastIndexOf("\\") + 1)
        .split(".")[1] === "csv"
    ) {
      this.setState({ file: e.target.files[0] });
    } else {
      this.setState({ fileError: true });
      setTimeout(() => {
        this.setState({ fileError: false });
      }, 3000);
    }
  };

  handleUpload = async (e) => {
    this.validationCheck();
    if ( this.state.file) {
      var formData = new FormData();
      formData.append("file", this.state.file);
      formData.append("customerId", this.state.customerId);
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/POI/POIBatchRegister`,
          formData,

          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status == "200") {
          this.setState({ successMsg: true });
          setTimeout(() => {
            this.setState({ successMsg: false });
          }, 3000);
        }
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  render() {
    const { customers, fileError, customerError, successMsg } = this.state;
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Create Point Of Interest </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h1>Upload CSV</h1>

              <Form>
                <Form.Group as={Row} controlId="formPlainTimeZone" hidden={localStorage.getItem('role') === "SystemAdmin" ? false : true} >
                  <Form.Label column sm="2">
                    Customer
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control as="select" onChange={this.handleCustomer}>
                      {customers.map((customer, index) => (
                        <option key={index}>{customer.name}</option>
                      ))}
                    </Form.Control>
                    <p
                      style={
                        customerError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Customer field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Upload csv file
                  </Form.Label>
                  <Col sm="10">
                    <input type="file" onChange={this.setFile} />
                  </Col>
                  <p
                    style={
                      fileError
                        ? {
                            color: "#a94442",
                            fontSize: "14px",
                            marginLeft: "13px",
                          }
                        : { display: "none" }
                    }
                  >
                    Please upload csv file
                  </p>
                </Form.Group>
                {this.state.error && (
                  <Row>
                    <Col sm="2"></Col>
                    <Col sm="9">
                      <p className="error-text">
                        Please fill all the Required fields
                      </p>
                    </Col>
                  </Row>
                )}
                <br />
              </Form>
              <br />
              <div className="footer-menu">
                <Button variant="outline-secondary" onClick={this.handleBack}>
                  Back to List
                </Button>
                &nbsp;
                <Button variant="outline-secondary" onClick={this.handleUpload}>
                  Upload CSV
                </Button>
                <p
                  style={
                    successMsg
                      ? { color: "green", fontSize: "14px", marginLeft: "10px" }
                      : { display: "none" }
                  }
                >
                  Upload is successful
                </p>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadCsv);
